import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "fromhere_cookie_ack_v1";

export default function CookieBanner() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(KEY)) setShow(true);
        } catch { /* private mode */ }
    }, []);

    const dismiss = () => {
        try { localStorage.setItem(KEY, "1"); } catch {}
        setShow(false);
    };

    if (!show) return null;

    return (
        <div data-testid="cookie-banner"
            className="fixed bottom-4 safe-bottom-tight left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[9999]
                       rounded-2xl bg-foreground text-background shadow-2xl p-4 flex items-start gap-3 fade-up">
            <div className="flex-1 text-sm">
                <div className="font-display font-bold text-base mb-1">Just so you know</div>
                <p className="text-background/80 leading-relaxed">
                    From Here uses one essential cookie to keep you signed in, plus product analytics (PostHog) to improve the app. No ads, ever.
                    See our <Link to="/privacy" className="underline hover:text-background">Privacy Policy</Link>.
                </p>
                <div className="mt-3">
                    <Button size="sm" onClick={dismiss} data-testid="cookie-banner-dismiss"
                        className="rounded-full bg-background text-foreground hover:bg-background/90 h-8">
                        Got it
                    </Button>
                </div>
            </div>
            <button onClick={dismiss} aria-label="Dismiss" className="text-background/60 hover:text-background">
                <X size={16} />
            </button>
        </div>
    );
}
